﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceKeeperView = void 0;
const ERC20Contract_1 = require("../../contracts/ERC20Contract");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
class PriceKeeperView extends com.CmpPriceKeeper {
    constructor(contract, asset) {
        super();
        this._contract = contract;
        this._init();
        this.ctrls.btnInfo.onclick = () => new modalCom.DialogOk("Contract address: " + this._contract.address + "<br><br>" + this.ctrls.lFaqInfo.text, "Info").show();
        this.ctrls.btnRefresh.onclick = () => this.refresh();
        this._asset = asset;
    }
    _init() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this._contract.getQuoteToken();
            const erc20 = new ERC20Contract_1.ERC20Contract(token, this._contract.web3);
            this._tokenName = yield erc20.symbol();
            this.ctrls.lTokenAddress.text = token;
            this.ctrls.lToken.text = `Price ${this._tokenName}:`;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnRefresh.disable();
            let price = (yield this._contract.getPrice()) + "";
            this._lastPrice = price;
            this.ctrls.btnRefresh.enable();
            let pre = price;
            let post = "";
            let dotIndex = price.indexOf('.');
            if (dotIndex < 20)
                price = price.slice(0, 20);
            else
                price = price.slice(0, dotIndex);
            if (price.length > 7) {
                pre = price.slice(0, dotIndex + 7);
                post = price.slice(dotIndex + 7);
            }
            this.ctrls.lPrice.html = `<span>${pre}</span><span>${post}</span> ${this._asset}`;
        });
    }
    getLastPrice() {
        return this._lastPrice;
    }
}
exports.PriceKeeperView = PriceKeeperView;
//# sourceMappingURL=PriceKeeperView.js.map